module.exports = __webpack_public_path__ + "static/Heebo-Light-eea345ff1a9795b038c76684ce688ba4.woff2";